import { ACTIVATE } from '../actions';

export const initialState = {
  error: null
};

export const activate = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATE._REQUEST: {
      state.error = null;
      return state;
    }
    case ACTIVATE._ERROR: {
      state.error = action.error;
      return state;
    }
    default:
      return state;
  }
};
